import { create } from "zustand";
import type { UserInfo } from "@/services/user/type";
import { getAuthSet } from "@/utils/authUtils";

export interface UserStore {
  userInfo?: UserInfo;
  authSet: Set<string>;
  setUserInfo: (data: UserInfo) => void;
}

const useUserStore = create<UserStore>((set) => ({
  userInfo: void 0,
  authSet: new Set(),
  setUserInfo: (data) => {
    const authSet = getAuthSet(data.menuList);

    set({ userInfo: data, authSet });
  },
}));

export default useUserStore;
